import {AfterViewInit, Component} from '@angular/core';
import {SuiLocalizationService} from 'ng2-semantic-ui';
import {tr} from '../assets/semantic/src/locales/tr';
import {ContentService} from "./shared/services/content/content.service";

declare let $: any;

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements AfterViewInit {
    title = 'app';

    constructor(public suiLocalizationService: SuiLocalizationService,
                private contentService: ContentService) {
        // Load the Spanish translations into the Localization Service.
        suiLocalizationService.load('tr', tr);
        // Set the current language to Spanish.
        suiLocalizationService.setLanguage('tr');


        /*
        Prevent Drop Events
         */
        window.addEventListener("dragover", function (e) {
            e.preventDefault();
            e.stopPropagation();
        }, false);
        window.addEventListener("drop", function (e) {
            e.preventDefault();
            e.stopPropagation();
        }, false);


        this.contentService.loadContent();
    }

    ngAfterViewInit(): void {
    }


}



// WEBPACK FOOTER //
// /var/www/luvi/frontend/src/app/app.component.ts